import { Footer } from "@nju/feature-portal-footer";
import { MaintenanceAlert } from "@nju/feature-portal-technical";
import { PanelPage } from "@nju/feature-sales-dashboard";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function Panel() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <MaintenanceAlert />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <ClientSideOnly>
          <PanelPage />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
